import { APP_HOST, PROTOCOL } from '../config';

export const getFullUrl = (path: string, forwardSlash = true) => {
  return `${PROTOCOL}${APP_HOST}${forwardSlash ? '/' : ''}${path}`;
};
